import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import Swal from 'sweetalert2';


@Component({
	selector: 'app-upload-doc-contract',
	templateUrl: './upload-doc-contract.component.html',
	styleUrls: ['./upload-doc-contract.component.scss'],
})
export class UploadDocContractComponent implements OnInit {
	@Input() client_id: number;
	@Input() contract_id: number;
	dataDocuments = new FormGroup({
		contract_sel: new FormControl('0'),
	});

	list_documents: any = [];
	loading_docs = false;
	files: any;
	rowsDocs: any = [];
	uploadedFiles : any[] = [];


	loading = false;
	uploading = false;
	loader = false;

	constructor(private contractSrv: ContractsService,) {}

	ngOnInit() {
		this.getDocuments();
	}

	saveDocument() {
		this.loading_docs = true;
		if (this.client_id > 0) {
			if (this.ValidateUploadDocuments()) {
				// let response_save_files=[]
				// var index=0;
				// let lis_response_saveFiles=[];

				for (var file of this.files) {
					var msj = '';
					var id = 0;
					var error = '';

					let formData = new FormData();
					formData.append('documents', file);
					formData.append('contract', this.dataDocuments.controls['contract_sel'].value);
					formData.append('user', '12');
					formData.append('customer', this.client_id.toString());

					// response_save_files.push([{nameFile:file.name, msg:msj, error:error, id:id}]);

					this.contractSrv.uploadDocument(formData).subscribe(
						(resp) => {
							msj = '';
							this.getListFiles(this.dataDocuments.controls['contract_sel'].value);
						},
						(error) => {
							msj += error;
						}
					);
					// index=index+1;
				}

				this.loading_docs = false;
			} else {
				Swal.fire({
					title: 'Message',
					text: 'Please select some contract and select some file to upload!.',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		}
	}

	ValidateUploadDocuments() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataDocuments.controls['contract_sel'].value === '' || this.dataDocuments.controls['contract_sel'].value === '0' || this.dataDocuments.controls['contract_sel'].value === null || this.dataDocuments.controls['contract_sel'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the contract.';
		}
		if ((this.list_documents.length = 0)) {
			respuesta = false;
			msgValidation += ' Select some document with relation to the contract.';
		}

		return respuesta;
	}

	getListFiles(contract_selected: any) {
		this.loading_docs = true;
		var contract_selected;
		if (this.client_id > 0) {
			this.contractSrv.getDocumentsByContract(contract_selected).subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.records.length > 0) {
						this.rowsDocs = data.records;
						this.loading_docs = false;
					} else {
						this.rowsDocs = [];
						this.loading_docs = false;
					}
				} else {
					this.rowsDocs = [];
					this.loading_docs = false;
				}
			});
		}
	}

	changeContract(event: any) {
		this.getListFiles(event.target.value);
	}

	handleFileSelect(evt: any) {
		this.files = evt.target.files; // FileList object
		for (var file of this.files) {
			// prints values: 10, 20, 30, 40
			this.list_documents.push(file.name);
		}
	}

	clearDocuments() {
		this.dataDocuments.reset();
		this.list_documents = [];
		this.dataDocuments = new FormGroup({
			contract_sel: new FormControl('0'),
		});
		this.rowsDocs = [];
	}



	onDragOver(event: DragEvent) {
		event.preventDefault(); // Evita que el navegador maneje el evento por defecto

		const dropzone = document.querySelector('.dropzone');
		if (dropzone) {
			dropzone.classList.add('dragging');
		}
	}

	onDragLeave(event: DragEvent) {
		event.preventDefault();
		const dropzone = document.querySelector('.dropzone');
		if (dropzone) {
			dropzone.classList.remove('dragging');
		}
	}

	onFileDropped(e) {
		this.loading = true;
		if (e.length > 0) {
			this.loader = true;
			const form = new FormData();
			form.append('contract_id', this.contract_id.toString());

			for (let index = 0; index < e.length; index++) {
				let name = 'file' + index;
				form.append(name, e[index]);
			}

			this.contractSrv.uploadContractDocument(form).subscribe((data: any)=>{
				this.getDocuments();
				this.loader = false;
				this.loading = false;
			});
		}
	}

	getDocuments(){
		this.contractSrv.getDocumentsByContractNew(this.contract_id).subscribe((data: any) => {
			this.uploadedFiles = data.body;
		});
	}


	deleteFile(name) {
		this.loading = true;
		const payload = {
			contract_id: this.contract_id,
			name: name
		}
		this.contractSrv.deleteFileNew(payload).subscribe((data:any)=>{
			this.getDocuments();
			this.loading = false;
		});
	}

	downloadFile(name){
		this.loading = true;
		const payload = {
			contract_id: this.contract_id,
			name: name
		}
		this.contractSrv.downloadContractDocument(payload).subscribe((data: any) => {
			this.showPdf(data.base64file, data.name);
			this.loading = false;
		});
	}

	showPdf(base64, name) {

		const linkSource = 'data:application/pdf;base64,' + base64;
		const downloadLink = document.createElement("a");
		const fileName = name;

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}

	formatName(text: string): string {
		return text.replace(/_/g, ' ');
	}


}
